import { SET_EDIT_USER_DATA } from '../actions/userActions';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_EDIT_USER_DATA:
      return action.user;
    default:
      return state;
  }
}
